import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InventoryTransactionsReport  {
    _originalTypeClassName = "zERP.BO.InventoryTransactionsReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InventoryTransactionsReport.translate = translateService;
}
this.Transactions = [];
this.PeriodSum = new Domain.InventoryTransactionsPeriodSum();
this.GlobalSum = new Domain.InventoryTransactionsGlobalSum();
this.DateFrom = null;
this.DateTo = null;
this.GoodCode = null;
this.GoodName = null;
this.GoodCategory = null;
this.GoodMeasurementUnit = null;
this.InventoryTransactionsReportKey = null;
this._key = this.InventoryTransactionsReportKey = 0; 
}

static translate: TranslateService;
_key: any;
DateFrom:any;
DateTo:any;
GoodCode:any;
GoodName:any;
GoodCategory:any;
GoodMeasurementUnit:any;
Transactions:any;
PeriodSum:any;
GlobalSum:any;
private _InventoryTransactionsReportKey:any;
get InventoryTransactionsReportKey(): any {
    return this._InventoryTransactionsReportKey;
  }
set InventoryTransactionsReportKey(value: any) {
    this._InventoryTransactionsReportKey = value;
    this._key = value;
  }
static setTransactions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Transactions == null) $this.Transactions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Transactions.length > 0) {
                    Domain.InventoryTransactionsReport.removeTransactions($this, $this.Transactions[0]);
                }

                Domain.InventoryTransactionsReport.addManyTransactions($this, copyItems);
            }
static addManyTransactions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InventoryTransactionsReport.addTransactions($this, items[i]);
                }
            }
static addTransactions = ($this, item) => {
                if ($this.Transactions == null) $this.Transactions = [];
                if (item == null || $this.Transactions.indexOf(item) > -1) return;
                $this.Transactions.push(item);
}
static addRangeTransactions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InventoryTransactionsReport.addTransactions($this, item));
            }
static removeTransactions = ($this, item) => {
                if ($this == null || $this.Transactions == null || $this.Transactions.indexOf(item) === -1) return;
                var _index = $this.Transactions.indexOf(item);
                $this.Transactions.splice(_index, 1);
}
static clearTransactions = ($this) => { $this.Transactions = null; }
static setPeriodSum = ($this, value) => {
var oldValue = $this.PeriodSum;
$this.PeriodSum = value;
if (value != null) {
}
}
static setGlobalSum = ($this, value) => {
var oldValue = $this.GlobalSum;
$this.GlobalSum = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InventoryTransactionsReportKey == null || $this.InventoryTransactionsReportKey == 0;
            }


}